var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useDispatch } from "react-redux";
import { submitSignupRepDetails } from "../../../reduxStore/actions/salesRepDataAction";
import { useTranslation } from "react-i18next";
import { checkEmailValidation } from "../../CustomerInvoice/Validation";
import { LoginComponentBL } from "../LoginComponentBL";
import { onlyNumbersRegex, onlyLettersRegex } from "../../../shared/regex";
import { getLoggedInRepDetails } from "../../../services/apiServices/salesRepDataService";
export function SignupComponentBL() {
    var _this = this;
    var _a, _b, _c;
    var maxLength = 10;
    var coverMessageMaxLength = 250;
    var cityStateMaxLength = 150;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _d = useState(), fileData = _d[0], setFileData = _d[1];
    var _e = useState(), cvFileData = _e[0], setCvFileData = _e[1];
    var _f = useState(false), loadingFlag = _f[0], setLoadingFlag = _f[1];
    var _g = useState(false), saveDetailsFlag = _g[0], setSaveDetailsFlag = _g[1];
    var _h = useState(""), responseMessage = _h[0], setResponseMessage = _h[1];
    var _j = useState({ fileName: "", filePath: "", fileSize: "" }), selectFile = _j[0], setSelectedFile = _j[1];
    var _k = useState({ fileName: "", filePath: "", fileSize: "" }), cvSelectFile = _k[0], setCvSelectedFile = _k[1];
    var _l = useState({
        open: false,
        msg: "",
        severity: "error",
    }), errorAlert = _l[0], setErrorAlert = _l[1];
    // Get config from LoginComponentBL which already handles window.salesteam_bo_props
    var config = LoginComponentBL().config;
    var registrationPage = config.Pages.Registration;
    var _m = useState({
        firstName: "",
        lastName: "",
        emailId: "",
        phoneNumber: "",
        city: "",
        state: "",
        fbHandle: "",
        instHandle: "",
        linkedin: "",
        coverMessage: "",
    }), requiredFields = _m[0], setRequiredFields = _m[1];
    var _o = useState({
        firstNameErrMsg: "",
        lastNameErrMsg: "",
        emailIdErrMsg: "",
        phoneNumberErrMsg: "",
        cityErrMsg: "",
        stateErrMsg: "",
        fileSizeErrMsg: "",
        cvFileErrMsg: "",
        coverMessageErrMsg: "",
    }), errMsgFields = _o[0], setErrMsgFields = _o[1];
    // Helper function to find a field label
    var findField = function (key) { var _a; return (_a = registrationPage.Fields) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.LabelKey === key; }); };
    var findFieldLabel = function (key, fallback) { var _a; return ((_a = findField(key)) === null || _a === void 0 ? void 0 : _a.LabelName) || fallback; };
    // fields: first and last name are always on top (0,1). Others (including email and phone) follow SequenceNo
    var sequencedFields = (registrationPage.Fields || [])
        .filter(function (f) { return !["firstName", "lastName"].includes(f.LabelKey); })
        .sort(function (a, b) { var _a, _b; return ((_a = a.SequenceNo) !== null && _a !== void 0 ? _a : 0) - ((_b = b.SequenceNo) !== null && _b !== void 0 ? _b : 0); });
    // Helper function to check if a field is required
    var isFieldRequired = function (fieldKey) {
        var _a;
        var field = (_a = registrationPage.Fields) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.LabelKey === fieldKey; });
        return (field === null || field === void 0 ? void 0 : field.IsRequired) || false;
    };
    // Check if profile photo is required and uploaded
    var isProfilePhotoValid = !isFieldRequired("profilePhoto") || (selectFile.filePath && selectFile.fileName);
    // Check if CV is required and uploaded
    var isCvValid = !isFieldRequired("cv") || (cvSelectFile.filePath && cvSelectFile.fileName);
    // Helper function to check if a text field is valid
    var isTextFieldValid = function (fieldKey) {
        if (!isFieldRequired(fieldKey))
            return true;
        // Map configuration field keys to state field keys
        var fieldKeyMap = {
            firstName: "firstName",
            lastName: "lastName",
            email: "emailId",
            phone: "phoneNumber",
            facebook: "fbHandle",
            instagram: "instHandle",
            linkedin: "linkedin",
            coverLetter: "coverMessage",
        };
        var stateFieldKey = fieldKeyMap[fieldKey] || fieldKey;
        var fieldValue = requiredFields[stateFieldKey];
        var isValid = fieldValue && fieldValue.length > 0;
        return isValid;
    };
    // Check all required fields dynamically
    var areAllRequiredFieldsValid = function () {
        if (!registrationPage.Fields)
            return false;
        var result = registrationPage.Fields.every(function (field) {
            if (!field.IsRequired)
                return true;
            var isValid = false;
            switch (field.LabelKey) {
                case "firstName":
                case "lastName":
                case "email":
                case "phone":
                case "facebook":
                case "instagram":
                case "linkedin":
                case "coverLetter":
                    isValid = isTextFieldValid(field.LabelKey);
                    break;
                case "profilePhoto":
                    isValid = isProfilePhotoValid;
                    break;
                case "cv":
                    isValid = isCvValid;
                    break;
                default:
                    isValid = true;
            }
            return isValid;
        });
        return result;
    };
    // City and State are a shop-specific customization (not part of the configurable fields); required when shown
    var shopName = ((_a = getLoggedInRepDetails()) !== null && _a !== void 0 ? _a : {}).shopName;
    var showCityState = shopName === "z0ritp-ea.myshopify.com";
    var isCityStateValid = !showCityState || (((_b = requiredFields.city) === null || _b === void 0 ? void 0 : _b.trim().length) > 0 && ((_c = requiredFields.state) === null || _c === void 0 ? void 0 : _c.trim().length) > 0);
    var signupBtnEnabled = areAllRequiredFieldsValid() &&
        isCityStateValid &&
        errMsgFields.firstNameErrMsg === "" &&
        errMsgFields.lastNameErrMsg === "" &&
        errMsgFields.emailIdErrMsg === "" &&
        errMsgFields.phoneNumberErrMsg === "" &&
        errMsgFields.cityErrMsg === "" &&
        errMsgFields.stateErrMsg === "" &&
        errMsgFields.fileSizeErrMsg === "" &&
        errMsgFields.cvFileErrMsg === "" &&
        errMsgFields.coverMessageErrMsg === "";
    var getUploadedFileDetails = function (event) {
        var file = event.target.files && event.target.files[0];
        if (!file)
            return;
        // Check file type for profile photo (PNG and JPG only)
        var allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        var isImage = allowedTypes.includes(file.type) ||
            (file.name && (file.name.toLowerCase().endsWith(".png") || file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg")));
        if (!isImage) {
            removeSelectedFile();
            setErrMsgFields(function (values) { return (__assign(__assign({}, values), { fileSizeErrMsg: "Only PNG and JPG files are allowed" })); });
            return;
        }
        if (file.size <= 5000000) {
            setSelectedFile({ fileName: file.name, filePath: URL.createObjectURL(file), fileSize: file.size });
            setFileData(file);
            setErrMsgFields(function (values) { return (__assign(__assign({}, values), { fileSizeErrMsg: "" })); });
        }
        else {
            removeSelectedFile();
            setErrMsgFields(function (values) { return (__assign(__assign({}, values), { fileSizeErrMsg: t("signup_fileSizeError") })); });
        }
    };
    var getUploadedCVDetails = function (event) {
        try {
            var file = event.target.files && event.target.files[0];
            if (!file)
                return;
            var isPdf = file.type === "application/pdf" || (file.name && file.name.toLowerCase().endsWith(".pdf"));
            if (!isPdf) {
                removeCvSelectedFile();
                setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cvFileErrMsg: "Only PDF files are allowed" })); });
                return;
            }
            if (file.size > 5000000) {
                removeCvSelectedFile();
                setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cvFileErrMsg: t("signup_fileSizeError") })); });
                return;
            }
            setCvSelectedFile({ fileName: file.name, filePath: URL.createObjectURL(file), fileSize: file.size });
            setCvFileData(file);
            setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cvFileErrMsg: "" })); });
        }
        catch (error) {
            console.log(error, "file upload error.");
        }
    };
    var removeSelectedFile = function () {
        setSelectedFile({ fileName: "", filePath: "", fileSize: "" });
    };
    var removeCvSelectedFile = function () {
        setCvSelectedFile({ fileName: "", filePath: "", fileSize: "" });
        setCvFileData(undefined);
    };
    var closeErrorAlert = function () {
        setErrorAlert(__assign(__assign({}, errorAlert), { open: false }));
    };
    var onInputClick = function (event) {
        event.target.value = "";
        setErrMsgFields(function (values) { return (__assign(__assign({}, values), { fileSizeErrMsg: "" })); });
    };
    var onInputCVClick = function (event) {
        event.target.value = "";
        setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cvFileErrMsg: "" })); });
    };
    var changeFormValue = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setRequiredFields(__assign(__assign({}, requiredFields), (_a = {}, _a[name] = value, _a)));
        formValidation(name, value);
    };
    var formValidation = function (name, value) {
        switch (name) {
            case "firstName":
                value === ""
                    ? setErrMsgFields(function (values) { return (__assign(__assign({}, values), { firstNameErrMsg: t("required_ErrorMsg") })); })
                    : setErrMsgFields(function (values) { return (__assign(__assign({}, values), { firstNameErrMsg: "" })); });
                break;
            case "lastName":
                value === ""
                    ? setErrMsgFields(function (values) { return (__assign(__assign({}, values), { lastNameErrMsg: t("required_ErrorMsg") })); })
                    : setErrMsgFields(function (values) { return (__assign(__assign({}, values), { lastNameErrMsg: "" })); });
                break;
            case "emailId":
                value === ""
                    ? setErrMsgFields(function (values) { return (__assign(__assign({}, values), { emailIdErrMsg: t("required_ErrorMsg") })); })
                    : checkEmailValidation(value.trim())
                        ? setErrMsgFields(function (values) { return (__assign(__assign({}, values), { emailIdErrMsg: t("emailValidation_ErrorMsg") })); })
                        : setErrMsgFields(function (values) { return (__assign(__assign({}, values), { emailIdErrMsg: "" })); });
                break;
            case "phoneNumber":
                if (value === "") {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { phoneNumberErrMsg: t("required_ErrorMsg") })); });
                }
                else if (!onlyNumbersRegex.test(value)) {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { phoneNumberErrMsg: "Phone number must contain only digits" })); });
                }
                else if ((value === null || value === void 0 ? void 0 : value.length) < maxLength) {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { phoneNumberErrMsg: t("signup_phone_number_Error") })); });
                }
                else {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { phoneNumberErrMsg: "" })); });
                }
                break;
            case "city":
                if (value.trim() === "") {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cityErrMsg: t("required_ErrorMsg") })); });
                }
                else if (!onlyLettersRegex.test(value.trim())) {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cityErrMsg: t("onlyLetters_ErrorMsg") })); });
                }
                else {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { cityErrMsg: "" })); });
                }
                break;
            case "state":
                if (value.trim() === "") {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { stateErrMsg: t("required_ErrorMsg") })); });
                }
                else if (!onlyLettersRegex.test(value.trim())) {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { stateErrMsg: t("onlyLetters_ErrorMsg") })); });
                }
                else {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { stateErrMsg: "" })); });
                }
                break;
            case "coverMessage":
                if (value.length >= 250) {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { coverMessageErrMsg: "Maximum 250 characters allowed" })); });
                }
                else {
                    setErrMsgFields(function (values) { return (__assign(__assign({}, values), { coverMessageErrMsg: "" })); });
                }
                break;
        }
    };
    var saveDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var signupRepDetails, responseData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingFlag(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    signupRepDetails = {
                        fileUpload: fileData,
                        cvUpload: cvFileData,
                        userDetails: requiredFields,
                    };
                    return [4 /*yield*/, dispatch(submitSignupRepDetails(signupRepDetails))];
                case 2:
                    responseData = _a.sent();
                    if (responseData.StatusCode === 200) {
                        setSaveDetailsFlag(true);
                        setCvFileData(undefined);
                        setResponseMessage((responseData === null || responseData === void 0 ? void 0 : responseData.StatusDescription) || "");
                        setSelectedFile({ fileName: "", filePath: "", fileSize: "" });
                        setCvSelectedFile({ fileName: "", filePath: "", fileSize: "" });
                        setRequiredFields({ firstName: "", lastName: "", emailId: "", phoneNumber: "", city: "", state: "", fbHandle: "", instHandle: "", linkedin: "", coverMessage: "" });
                    }
                    else {
                        setErrorAlert({
                            open: true,
                            msg: (responseData === null || responseData === void 0 ? void 0 : responseData.StatusDescription) || "An error occurred while saving details. Please try again.",
                            severity: "error",
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setErrorAlert({
                        open: true,
                        msg: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || "An unexpected error occurred. Please try again.",
                        severity: "error",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingFlag(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        t: t,
        registrationPage: registrationPage,
        sequencedFields: sequencedFields,
        findFieldLabel: findFieldLabel,
        coverMessageMaxLength: coverMessageMaxLength,
        cityStateMaxLength: cityStateMaxLength,
        showCityState: showCityState,
        getUploadedFileDetails: getUploadedFileDetails,
        getUploadedCVDetails: getUploadedCVDetails,
        selectFile: selectFile,
        cvSelectFile: cvSelectFile,
        signupBtnEnabled: signupBtnEnabled,
        requiredFields: requiredFields,
        errMsgFields: errMsgFields,
        changeFormValue: changeFormValue,
        removeSelectedFile: removeSelectedFile,
        removeCvSelectedFile: removeCvSelectedFile,
        saveDetails: saveDetails,
        saveDetailsFlag: saveDetailsFlag,
        loadingFlag: loadingFlag,
        onInputClick: onInputClick,
        onInputCVClick: onInputCVClick,
        responseMessage: responseMessage,
        errorAlert: errorAlert,
        closeErrorAlert: closeErrorAlert,
    };
}
